import React from "react";
import Loadable from "../../react-loadable";
import "./index.less";

const WeaSignature = Loadable({
  loader: () => import("./Signature"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});

export default WeaSignature;



// WEBPACK FOOTER //
// ./ecology9/wea-signature/index.js